import React, { useRef, useEffect } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import classes from './App.module.scss';

export default function GoogleMap({ location, center, zoom }) {
	const mapRef = useRef();

	useEffect(() => {
		const loader = new Loader({
			apiKey: 'AIzaSyDrurEyOPwquqUwQ0HkATFnK0wLBSU0JE4',
			version: 'weekly',
		});

		loader.load().then(() => {
			const map = new window.google.maps.Map(mapRef.current, {
				center: center,
				zoom: zoom,
			});

			if (location) {
				new window.google.maps.Marker({
					position: location,
					map: map,
					title: 'Bman.ro',
				});
			}
		});
	}, [location, center, zoom]);

	return <div className={classes['map']} ref={mapRef} style={{ width: '100%', height: '200px' }}></div>;
}
